module.exports = __webpack_public_path__ + "static/books-site-9c2ba3940efb2c55bb9f02376c1b6509.jpg";